import { NoContentPlaceholder } from "../../../../../components/NoContentPlaceholder.js";
import { useRecordTags } from "../../../hooks/useRecordTags.js";
import { useMemo } from "react";
import { Button, Icon, Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdLabelOff } from "react-icons/md";
import { useFormikContext } from "formik";
//#region src/modules/Records/shared/RecordForm/components/TagsTab.tsx
function TagsTab() {
	const { setFieldValue, values } = useFormikContext();
	const { data, loading } = useRecordTags({ typeFilter: values.type ? [values.type] : void 0 });
	const selectedTagsByTitle = useMemo(() => {
		if (!values.tags) return {};
		return Object.fromEntries(values.tags.map((tag) => [tag.title, true]));
	}, [values.tags]);
	const toggleTag = (tag) => {
		let tags;
		if (values.tags && selectedTagsByTitle[tag.title]) tags = values.tags.filter(({ title }) => title !== tag.title);
		else if (values.tags) tags = [...values.tags, tag];
		else tags = [tag];
		setFieldValue("tags", tags);
	};
	if (loading && !data?.tags) return /* @__PURE__ */ jsx("div", {
		className: "flex justify-center",
		children: /* @__PURE__ */ jsx(Loading, {
			message: "Loading Record Tags",
			messagePosition: "vertical",
			size: "lg",
			className: "mt-lg"
		})
	});
	if (!data?.tags) return /* @__PURE__ */ jsx(NoContentPlaceholder, {
		className: "text-md mt-xl",
		icon: /* @__PURE__ */ jsx(Icon, {
			Icon: MdLabelOff,
			size: "xxl"
		}),
		children: "There are no Tags for this Record type."
	});
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
		className: "mt-sm flex flex-wrap gap-xs grow",
		children: data.tags.map((tag) => /* @__PURE__ */ jsxs("div", {
			className: classnames({
				"bg-main-faded text-color-strong": selectedTagsByTitle[tag.title],
				"bg-surface-subtle opacity-50": !selectedTagsByTitle[tag.title]
			}, "transition flex cursor-pointer hover:brightness-125 hover:opacity-100 focus:brightness-125 focus:opacity-100 active:brightness-75 select-none rounded min-w-72 grow basis-0"),
			onClick: () => toggleTag(tag),
			children: [/* @__PURE__ */ jsx("div", {
				className: "w-xxs self-stretch rounded-l",
				style: { backgroundColor: tag.color }
			}), /* @__PURE__ */ jsx("span", {
				className: "py-xs px-sm shrink-0",
				children: tag.title
			})]
		}, tag.title))
	}), /* @__PURE__ */ jsxs("div", {
		className: "flex items-center justify-between mt-base",
		children: [/* @__PURE__ */ jsx("div", {
			className: "text-color-subtle text-sm ",
			children: "Select the tags to associate with the Record."
		}), /* @__PURE__ */ jsx(Button, {
			disabled: !values.tags || !values.tags.length,
			onClick: () => {
				setFieldValue("tags", []);
			},
			subtle: true,
			children: "Clear All"
		})]
	})] });
}
//#endregion
export { TagsTab };

//# sourceMappingURL=TagsTab.js.map